import axios from 'axios';
import { store, persistor } from './store';
import { clearCredentials } from './store/user/authSlice';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3200',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isLoggingOut = false;

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401 && !isLoggingOut) {
      const url = error.config?.url || '';
      if (url.includes('/otp/')) {
        return Promise.reject(error);
      }

      isLoggingOut = true;

      console.warn('Session expired. Logging out...');

      localStorage.removeItem('authToken');
      store.dispatch(clearCredentials());
      await persistor.purge();

      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;
